import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { ProcessAppraiseeApproval, 
  ProcessRespondentsApproval, 
  KnownProcessType} from '../../models/process-models';
import { ActivatedRoute } from '@angular/router';
import { ProcessService } from '../../services/process.service';
import { EmployeeApprovalSearchRequest, Employee } from '../../models/identity';
import { ConfigService } from '../../services/config.service';
import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment';
import { EnumDescription } from '../../helpers/enum-description.helper';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-respondents-approval-search-page-header',
  templateUrl: './respondents-approval-search-page-header.component.html',
  styleUrls: ['./respondents-approval-search-page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RespondentsApprovalSearchPageHeaderComponent implements OnInit {

  @Input() processRespondentsApproval: Array<ProcessRespondentsApproval>;
  @Input() hideApproveButton: Array<boolean>;
  @Output() searchRequestLoaded = new EventEmitter<EmployeeApprovalSearchRequest>();
  @Output() getAppraisee = new EventEmitter<Employee>();
  @Output() approveClicked = new EventEmitter();
 

  processAppraiseeDurationId: number;
  requirementType: number;
  employeeApprovalSearchRequest: EmployeeApprovalSearchRequest = {};
  processAppraiseeApproval$: Observable<ProcessAppraiseeApproval>;
  
  private isInit = false;
  constructor(private route: ActivatedRoute, private processService: ProcessService,
    private readonly cookieService: CookieService, 
    private readonly languageService: LanguageService,
    private readonly configService: ConfigService) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.processAppraiseeDurationId = +params.get('id');
      this.requirementType = +params.get('requirementType');
      this.processAppraiseeApproval$ = this.processService
        .getProcessApprovalByAppraiseeDurationId(this.requirementType, this.processAppraiseeDurationId);
    });
    this.changeLanguage();
  }
  
  getComponentData(processAppraiseeApproval: ProcessAppraiseeApproval) {
    if (this.isInit) {
      return;
    }
    this.isInit = true;
    this.employeeApprovalSearchRequest.appraiseeGradeLevel = processAppraiseeApproval.appraisee.grade.gradeLevel;
    this.employeeApprovalSearchRequest.appraiseePersonId = processAppraiseeApproval.appraisee.personId;
    this.searchRequestLoaded.emit(this.employeeApprovalSearchRequest);
    this.getAppraisee.emit(processAppraiseeApproval.appraisee);
  }

  approve() {
    this.approveClicked.emit();
  }

  formatDate(startDate: string): string {
    const appLanguage = this.cookieService.get(this.configService.configData.cookieLanguageNameKey);
    return moment(new Date(startDate)).locale(appLanguage).format('DD MMMM YYYY');
  }

  getProcessTypes(processKnownTypes: Array<number>): Array<string> {
    return processKnownTypes.map(x => EnumDescription.GetDescription(KnownProcessType, x));
  }

  cantApprove(): boolean {
    if (!this.processRespondentsApproval) {
      return false;
    }
    return this.processRespondentsApproval.some(x => +x.value > x.respondents.length);
  }

  private changeLanguage() {
    this.languageService.languageChanged$
    .subscribe(selectedLanguage => {
      this.processAppraiseeApproval$ = this.processService
    .getProcessApprovalByAppraiseeDurationId(this.requirementType, this.processAppraiseeDurationId);
    });
  }
}
